import type { State } from "@hookstate/core";
import React, { useState } from "react";
import type { ICheckoutMaterial, IWarehouseCheckout } from "../../interface";
import { useLang } from "~/hooks/useLang";
import { Grid, TextField, Typography } from "@mui/material";
import NumberField from "~/components/NumberField";

interface MaterialCheckinProps {
  readonly warehouseCheckout: State<IWarehouseCheckout | null>
  readonly hasSubmitted: boolean
}

function isNotesRequired(equipment: ICheckoutMaterial): boolean {
  return !!equipment.quantityAtCheckin
}


export default function MaterialCheckin({ warehouseCheckout, hasSubmitted }: MaterialCheckinProps) {
  const { translate } = useLang();
  const [commentNotes, setCommentNotes] = useState<string>('')

  return (
    <>
      <Typography variant="h6" marginBottom={2}>
        {translate('Materials')}
      </Typography>
      <Grid container xs={12} spacing={2} marginBottom={2} sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: 2 }}>
        {warehouseCheckout.get()?.checkoutMaterials.map((material, index) => {
          return (
            <Grid key={material.id} item container xs={12} spacing={2} sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
              <Grid item xs={2} >
                <TextField
                  id="outlined-start-adornment"
                  fullWidth
                  size="small"
                  label={'Equipamento'}
                  disabled={true}
                  value={material.material.name}
                />
              </Grid>
              <Grid item xs={2} >
                <TextField
                  id="outlined-start-adornment"
                  fullWidth
                  size="small"
                  label={'Grupo de Material'}
                  disabled={true}
                  value={material.material.materialGroup?.name}
                />
              </Grid>
              <Grid item xs={2} >
                <TextField
                  id="outlined-start-adornment"
                  fullWidth
                  size="small"
                  label={'Código'}
                  disabled={true}
                  value={material.material.code}
                />
              </Grid>
              <Grid item xs={3} >
                <TextField
                  id="outlined-start-adornment"
                  fullWidth
                  size="small"
                  label={translate("Notes")}
                  disabled={false}
                  value={commentNotes}
                  onChange={(event) => {
                    setCommentNotes(event.target.value)
                    warehouseCheckout['checkoutMaterials'][index].notes.set(event.target.value)
                  }}
                  required={isNotesRequired(material)}
                  error={hasSubmitted && warehouseCheckout['checkoutMaterials'][index].quantityAtCheckin.get() != warehouseCheckout['checkoutMaterials'][index].quantityAtCheckout.get()}
                  multiline={true}
                  rows={4}
                  sx={{ height: 92 }}
                />
              </Grid>
              <Grid item xs={1}>
                <NumberField
                  label={translate('Quantity')}
                  value={material.quantityAtCheckin}
                  // defaultValue={material.quantityAtCheckout}
                  onValueChange={(value) => warehouseCheckout['checkoutMaterials'][index].quantityAtCheckin.set(value)}
                  size="small"
                  min={0}
                  max={warehouseCheckout['checkoutMaterials'][index].quantityAtCheckout.get()}
                />
              </Grid>
            </Grid>
          )
        })}
      </Grid>
    </>
  )
}